var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-3.496 6.22A8.97 8.97 0 0 1 12 21a8.97 8.97 0 0 1-6.504-2.78 9 9 0 0 1 .352-.302c.329-.269.809-.63 1.41-.99C8.462 16.206 10.122 15.5 12 15.5c1.877 0 3.537.705 4.743 1.429.6.36 1.08.72 1.41.99.15.122.268.226.351.302Zm.65-.76a13 13 0 0 0-1.898-1.39c-1.293-.775-3.133-1.57-5.256-1.57s-3.963.795-5.257 1.571a13 13 0 0 0-1.898 1.39 9 9 0 1 1 14.31 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgUserCircle;